import { useCallback } from "react";

import { get } from "@s-libs/micro-dash";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";
import useUser from "@/users/useUser";

const mapSchoolFormData = (schoolFormData, districtData) => {
  const { id: districtId } = districtData;
  const { schoolName, website, city, state, streetAddress, zip, suite } =
    schoolFormData;

  return {
    name: schoolName.value,
    website: website.value ?? null,
    district_id: districtId,
    address: {
      city: city.value,
      state: state.value.abbreviation,
      address1: streetAddress.value,
      zip_code: zip.value,
      address2: suite.value ?? null,
    },
  };
};

const useAdminConsoleAddSchool = () => {
  const { data: user } = useUser();
  const districtData = get(user, ["district_admin", "district"], null);

  const createAddSchoolPostRequest = useCallback((schoolFormData) => {
    const payload = mapSchoolFormData(schoolFormData, districtData);
    const requestConfig = {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    };

    return new Request(`${MONOLITH_ORIGIN}/api/v2/school/`, requestConfig);
  }, []);

  return useRestMutation(createAddSchoolPostRequest);
};

export default useAdminConsoleAddSchool;
